import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { APP_NAME } from '../config';
import { useAuth } from '../contexts/useAuth';
import { useConnection } from '../contexts/useConnection';
import { useTheme } from '../contexts/useTheme';
import Footer from './Footer';
import OfflineBanner from './OfflineBanner';

export default function Layout() {
  const { isLoggedIn, user, logout } = useAuth();
  const { isOnline } = useConnection();
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  return (
    <div className="d-flex flex-column" style={{ minHeight: '100vh' }}>
      <nav className={`navbar navbar-expand-md fixed-top navbar-dark ${theme === 'dark' ? '' : 'bg-primary'}`} style={theme === 'dark' ? { backgroundColor: 'var(--bs-gray-800)' } : undefined}>
        <div className="container-fluid">
          <NavLink className="navbar-brand" to="/">{APP_NAME}</NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label="내비게이션 토글"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarCollapse">
            <ul className="navbar-nav me-auto mb-2 mb-md-0">
              <li className="nav-item">
                <NavLink className="nav-link" to="/calc">계산하기</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/db">캐릭터 입력</NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/guide">설명서</NavLink>
              </li>
            </ul>
            <ul className="navbar-nav ms-auto mb-2 mb-md-0">
              <li className="nav-item d-flex align-items-center me-2">
                <div className="form-check form-switch mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    role="switch"
                    id="themeSwitch"
                    checked={theme === 'dark'}
                    onChange={toggleTheme}
                  />
                  <label className="form-check-label text-light" htmlFor="themeSwitch">
                    {theme === 'dark' ? '🌙' : '☀️'}
                  </label>
                </div>
              </li>
              {isLoggedIn ? (
                <>
                  <li className="nav-item">
                    <NavLink className="nav-link" to="/mypage">{user?.username}</NavLink>
                  </li>
                  <li className="nav-item">
                    <button className="nav-link btn btn-link" onClick={handleLogout}>로그아웃</button>
                  </li>
                </>
              ) : (
                <li className="nav-item">
                  {isOnline ? (
                    <NavLink className="nav-link" to="/login">로그인</NavLink>
                  ) : (
                    <span className="nav-link disabled" tabIndex={-1} aria-disabled="true">로그인 (오프라인)</span>
                  )}
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>

      <div style={{ paddingTop: '3.5rem' }}>
        <OfflineBanner />
      </div>

      <main className="container flex-grow-1" style={{ paddingBottom: '1rem' }}>
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
